/** Mirrors the contract's PollStatus enum. */
export const MarketStatus = {
    Created: 0,
    Active: 1,
    BiddingClosed: 2,
    Resolved: 3,
    Cancelled: 4,
};

export const STATUS_LABELS = {
    [MarketStatus?.Created]: "Scheduled",
    [MarketStatus?.Active]: "Open",
    [MarketStatus?.BiddingClosed]: "Locked",
    [MarketStatus?.Resolved]: "Settled",
    [MarketStatus?.Cancelled]: "Voided",
};

/* Contract custom-error names → what the user is told. */
export const CONTRACT_ERRORS = {
    // OpenZeppelin ERC20InsufficientAllowance, by name or raw selector (wallets often only show the selector)
    ERC20InsufficientAllowance: "Token approval is missing or too low. Approve the token again, then confirm your forecast.",
    "0xfb8f41b2": "Token approval is missing or too low. Approve the token again, then confirm your forecast.",
    PollNotFound: "That market does not exist",
    BiddingNotOpen: "This market is not taking forecasts right now",
    BiddingNotEnded: "The forecasting window is still running",
    BidTooLow: "Stake is below the market minimum",
    InvalidPollStatus: "This action is not available right now",
    EnforcedPause: "Market is temporarily paused",
    ExpectedPause: "The market is not paused",
    InvalidOutcome: "Pick one of the listed outcomes",
    InvalidOutcomeCount: "A market needs at least two outcomes",
    NoOutcomeSwitching: "You already backed a different outcome in this market",
    NoOpposition: "Every stake is on one side — the market cannot settle",
    NotAWinner: "Your outcome did not win this market",
    AlreadyClaimed: "This payout was already collected",
    AlreadyRefunded: "This refund was already collected",
    NothingToRefund: "There is nothing to refund here",
    TokenNotAllowed: "That token is not accepted for staking",
    InvalidTimeRange: "Opening and closing times do not line up",
    ZeroAddress: "An address is missing",
    TransferFailed: "The token transfer failed",
    ZeroAmount: "Enter an amount above zero",
    SelfReferral: "You cannot refer your own wallet",
    CircularReferral: "That referral would loop back on itself",
    NothingToClaim: "No referral earnings to collect yet",
    InsufficientFees: "Requested more than the fees collected",
};

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";
export const FEE_BPS = 1000; // fixed 10% platform fee, set in the contract
export const BONUS_BPS = 1000; // fixed 10% bonus pool (leaderboard rewards); anything unspent goes to fees
export const WINNERS_BPS = 8000; // the remaining 80% is shared by the winners pro-rata
export const BPS_DENOMINATOR = 10_000;

export const REFERRAL_BPS = 500; // 5% of a winner's payout is deducted and accrued to their referrer
